module.exports = __webpack_public_path__ + "img/gridbg1.ae8ccd8b.png";